<main>
  <div class="wip">
    <div class="flex justify-end" style="padding: 24px 12px;">
      <button mat-flat-button color="primary" (click)="reload()">Torna alla login</button>
    </div>
    <div class="info-box">
      <h1 style="font-size: 40px; font-weight: 700;">{{title}}</h1>
      <p class="light">{{subtitle}}</p>
    </div>
    <!--     <img class="wip-image" src="assets/images/manutenzione@2x.png" />
 -->
  </div>
</main>
